var _path, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongrats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755,
    height: 163,
    viewBox: "0 0 755 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445 70C445 103.137 418.137 130 385 130C351.863 130 325 103.137 325 70C325 36.8629 351.863 10 385 10C418.137 10 445 36.8629 445 70ZM335.039 70C335.039 97.5929 357.407 119.961 385 119.961C412.593 119.961 434.961 97.5929 434.961 70C434.961 42.4071 412.593 20.0387 385 20.0387C357.407 20.0387 335.039 42.4071 335.039 70Z",
    fill: "#128808",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_2401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.165 89.1663L408.54 59.7913L402.707 53.958L379.165 77.4997L367.29 65.6247L361.457 71.458L379.165 89.1663ZM384.999 111.666C379.235 111.666 373.818 110.573 368.749 108.385C363.679 106.198 359.27 103.229 355.52 99.4788C351.77 95.7288 348.801 91.3191 346.613 86.2497C344.426 81.1802 343.332 75.7636 343.332 69.9997C343.332 64.2358 344.426 58.8191 346.613 53.7497C348.801 48.6802 351.77 44.2705 355.52 40.5205C359.27 36.7705 363.679 33.8018 368.749 31.6143C373.818 29.4268 379.235 28.333 384.999 28.333C390.763 28.333 396.179 29.4268 401.249 31.6143C406.318 33.8018 410.728 36.7705 414.478 40.5205C418.228 44.2705 421.197 48.6802 423.384 53.7497C425.572 58.8191 426.665 64.2358 426.665 69.9997C426.665 75.7636 425.572 81.1802 423.384 86.2497C421.197 91.3191 418.228 95.7288 414.478 99.4788C410.728 103.229 406.318 106.198 401.249 108.385C396.179 110.573 390.763 111.666 384.999 111.666Z",
    fill: "#128808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 70C435 97.6142 412.614 120 385 120C357.386 120 335 97.6142 335 70C335 42.3858 357.386 20 385 20C412.614 20 435 42.3858 435 70ZM343.627 70C343.627 92.8496 362.15 111.373 385 111.373C407.85 111.373 426.373 92.8496 426.373 70C426.373 47.1504 407.85 28.6272 385 28.6272C362.15 28.6272 343.627 47.1504 343.627 70Z",
    fill: "#128808",
    fillOpacity: 0.4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 80,
    r: 10,
    fill: "#0015FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 10,
    r: 10,
    fill: "#FF00CC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 110,
    r: 10,
    fill: "#0015FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 28,
    r: 10,
    fill: "#FF0000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 683,
    cy: 70,
    r: 10,
    fill: "#FF00CC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 745,
    cy: 140,
    r: 10,
    fill: "#FFC61C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 30,
    r: 10,
    fill: "#128808"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 153,
    r: 10,
    fill: "#FF0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_2401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(335 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.15127219134d595c44b6e9937e871899.svg";
export { ForwardRef as ReactComponent };